import { ActionTypes } from "../contants/action-types";

const initialState = {
  applications: [],
};

export const applicationsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case ActionTypes.FETCH_APPLICATIONS:
      return { ...state, applications: payload };
    default:
      return state;
  }
};